import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
  Input,
} from '@angular/core';
import { MatCardActions } from '@angular/material/card';
import { LegacyModeService } from '@boldpenguin/emperor-services';
import { EmperorCardHeaderColor } from '../../../models';

@Component({
  selector: 'emperor-card-footer',
  templateUrl: './card-footer.component.html',
  styleUrls: ['./card-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmperorCardFooterComponent extends MatCardActions {
  /**
   * @deprecated in M3
   */
  @Input() color: EmperorCardHeaderColor;
  private legacyService = inject(LegacyModeService, { optional: true });

  @HostBinding('class.emperor-ui-none') noColor = true;
  @HostBinding('class.emperor-ui-default') defaultColor = false;
  @HostBinding('class.emperor-ui-primary') primaryColor = false;
  @HostBinding('class.emperor-ui-accent') accentColor = false;
  @HostBinding('class.emperor-ui-warn') warnColor = false;

  ngOnChanges() {
    this.defaultColor = !this.color;
    this.primaryColor = this.color === EmperorCardHeaderColor.PRIMARY;
    this.accentColor = this.color === EmperorCardHeaderColor.ACCENT;
    this.warnColor = this.color === EmperorCardHeaderColor.WARN;
    this.noColor = this.color === EmperorCardHeaderColor.NONE;
  }

  @HostBinding('class')
  get hostClass(): string | null {
    if (!this.legacyService?.getLegacyMode()) {
      return null;
    }

    return 'emperor-ui-card-footer';
  }
}
